'use client';

import clsx from 'clsx';

import ForgotPassForm from '@/components/elements/AuthForms/ForgotPassForm';
import LoginForm from '@/components/elements/AuthForms/LoginForm';
import SignUpForm from '@/components/elements/AuthForms/SignUpForm';
import CloseDrawerIcon from '@/components/icons/CloseDrawerIcon';
import useLoginDrawer from '@/hooks/useLoginDrawerStore';

function LoginDrawer() {
  const { closeDrawer, loginDrawerType } = useLoginDrawer();

  if (!loginDrawerType) return null;

  return (
    <>
      <div
        onClick={closeDrawer}
        className={clsx(
          'fixed inset-0 z-40 bg-black/40 backdrop-blur-sm transition-opacity duration-300',
          loginDrawerType ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0',
        )}
      />
      <aside
        className={clsx(
          'fixed top-0 bottom-0 z-50 h-full w-full bg-white shadow-lg transition duration-700 ease-in-out sm:w-82 md:w-140',
          loginDrawerType ? 'right-0' : '-right-[100%]',
        )}
      >
        <div className="border-secondary-stroke flex items-center justify-between border-b-1 border-solid px-5 py-4 md:px-6 md:py-7">
          <p className="text-label-md font-semibold tracking-normal text-black">
            {loginDrawerType === 'login' && 'Login'}
            {loginDrawerType === 'register' && 'Sign Up'}
            {loginDrawerType === 'forgot_pass' && 'Recover Password'}
          </p>
          <button
            onClick={closeDrawer}
            className="flex h-6 w-6 min-w-6 items-center justify-center border-none"
          >
            <CloseDrawerIcon />
          </button>
        </div>
        {loginDrawerType === 'login' && <LoginForm closeForm={closeDrawer} />}
        {loginDrawerType === 'register' && <SignUpForm closeForm={closeDrawer} />}
        {loginDrawerType === 'forgot_pass' && <ForgotPassForm closeForm={closeDrawer} />}
      </aside>
    </>
  );
}

export default LoginDrawer;
